import { makeAutoObservable } from 'mobx'
import {
  SurveysFollowUpAssertiveness,
  type ISurveysFollowUpAssertiveness,
  type ISurveySettings,
} from 'entities/Surveys/api/types'

export class FallbackActionsStore {
  static DefaultFollowUpWindow = 3
  static DefaultSessionLifetime = 3

  autoFollowUpEnabled = true
  followUpWindow = FallbackActionsStore.DefaultFollowUpWindow
  followUpAssertiveness: ISurveysFollowUpAssertiveness = SurveysFollowUpAssertiveness.Steady
  sessionLifetime = FallbackActionsStore.DefaultSessionLifetime

  constructor() {
    makeAutoObservable(this)
  }

  setAutoFollowUpEnabled = (value: boolean) => {
    this.autoFollowUpEnabled = value
  }

  setFollowUpWindow = (value: number) => {
    this.followUpWindow = value
  }

  setFollowUpAssertiveness = (value: ISurveysFollowUpAssertiveness) => {
    this.followUpAssertiveness = value
  }

  setSessionLifetime = (value: number) => {
    this.sessionLifetime = value
  }

  syncOrigin(settings?: ISurveySettings | null) {
    this.autoFollowUpEnabled = settings?.fallback_auto_follow_up?.value ?? true
    this.followUpWindow =
      settings?.fallback_auto_follow_up_window?.value ?? FallbackActionsStore.DefaultFollowUpWindow
    this.followUpAssertiveness =
      settings?.fallback_auto_follow_up_frequency?.value ?? SurveysFollowUpAssertiveness.Steady
    this.sessionLifetime =
      settings?.fallback_end_session?.value ?? FallbackActionsStore.DefaultSessionLifetime
  }

  get params(): Pick<
    ISurveySettings,
    | 'fallback_auto_follow_up'
    | 'fallback_auto_follow_up_window'
    | 'fallback_auto_follow_up_frequency'
    | 'fallback_end_session'
  > {
    return {
      fallback_auto_follow_up: { value: this.autoFollowUpEnabled },
      fallback_auto_follow_up_window: { value: this.followUpWindow },
      fallback_auto_follow_up_frequency: { value: this.followUpAssertiveness },
      fallback_end_session: { value: this.sessionLifetime },
    }
  }
}
